<template>
  <div class="border-t border-surface-100 p-3">
    <div
      :class="[
        'flex cursor-text items-center gap-2 rounded-xl border border-surface-200 bg-surface-50 px-3 py-2 transition',
        disabled ? 'opacity-50' : 'focus-within:border-primary-400 focus-within:bg-surface-0',
      ]"
      @click="input_ref?.focus()"
    >
      <textarea
        ref="input_ref"
        v-model="query"
        rows="1"
        maxlength="1000"
        :placeholder="$t('ai.assistant.input.placeholder')"
        class="flex-1 resize-none bg-transparent text-sm text-surface-800 placeholder-surface-400 outline-none"
        :disabled="is_loading || disabled"
        @keydown.enter.exact.prevent="handleSubmit"
        @input="auto_resize"
      />
      <button
        :disabled="!query.trim() || is_loading || disabled"
        :class="[
          'flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-lg transition',
          query.trim() && !is_loading && !disabled
            ? 'bg-primary-500 text-white hover:bg-primary-600'
            : 'cursor-not-allowed bg-surface-200 text-surface-400',
        ]"
        @click="handleSubmit"
      >
        <FontAwesomeIcon
          icon="paper-plane"
          class="text-xs"
        />
      </button>
    </div>
    <p class="mt-1.5 text-center text-xs text-surface-400">{{ $t('ai.assistant.input.hint') }}</p>
    <p class="mt-0.5 text-center text-[10px] text-surface-400/70">{{ $t('ai.assistant.input.disclaimer') }}</p>
  </div>
</template>

<script setup>
import { nextTick, onMounted, ref } from 'vue';

const props = defineProps({
  is_loading: { type: Boolean, required: true },
  disabled: { type: Boolean },
});

const emit = defineEmits(['submit']);

const query = ref('');
const input_ref = ref(null);

onMounted(() =>
  nextTick(() => {
    if (input_ref.value) input_ref.value.focus();
  }),
);

const auto_resize = (e) => {
  const el = e.target;
  el.style.height = 'auto';
  el.style.height = `${Math.min(el.scrollHeight, 120)}px`;
};

const handleSubmit = () => {
  if (!query.value.trim() || props.is_loading || props.disabled) return;
  emit('submit', query.value.trim());
  query.value = '';
  nextTick(() => {
    if (input_ref.value) input_ref.value.style.height = 'auto';
  });
};
</script>
